import * as React from "react"
import { Navigate } from "react-router-dom"

import { BRANDS_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import BrandsCrudPage from "./Brand"


export const BrandsRoutes = {
    path: BRANDS_ROUTES.PATH,
    title: "Brands",
    icon: 'tags',
    element: <AppLayout />,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <Navigate to={BRANDS_ROUTES.CRUD_PATH} replace />, index: true
    }, {
        path: BRANDS_ROUTES.CRUD_PATH,
        element: <BrandsCrudPage />
    }]
}